import { render } from "./SettingsExportImport.vue?vue&type=template&id=4a18814c&scoped=true"
import script from "./SettingsExportImport.vue?vue&type=script&lang=js"
export * from "./SettingsExportImport.vue?vue&type=script&lang=js"

import "./SettingsExportImport.vue?vue&type=style&index=0&id=4a18814c&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a18814c"]])

export default __exports__